import { renamingUITaExact, renamingUITaContains } from 'config/renaming-ui-users';
import { FullTargetAudience } from '../types';

type RawTargetAudience = Omit<FullTargetAudience, 'displayedName'>;

const isRenamingTargetAudience = (name: string): boolean => renamingUITaExact.includes(name) ||
  renamingUITaContains.some((checkingName) => name.includes(checkingName));

export const getRenamedTargetAudiences = (
  targetAudiences: RawTargetAudience[],
  type: 'federal' | 'regional'
): FullTargetAudience[] => {
  const seenNames = {
    federal: new Set(),
    regional: new Set(),
  };

  return targetAudiences.reduce<FullTargetAudience[]>((acc, ta) => {
    if (!isRenamingTargetAudience(ta.name)) {
      return acc;
    }
    if (seenNames[type].has(ta.name)) {
      return acc;
    }

    seenNames[type].add(ta.name);
    const displayedName = ta.groupName
      ? `${ta.groupName} / ${ta.name}`
      : ta.name;

    return [...acc, { ...ta, displayedName }];
  }, []);
};
